import { RootState } from '../typedefs/store';

interface WindowWithGA extends Window {
    GoogleAnalyticsObject?: any;
    DIDataLayer?: any;
}
declare var window: WindowWithGA;

export const getSettings = (state: RootState) => {
    let settings = state.settings;
    let globalVehicle = null;
    let overrideVehicle = null;

    // Check the global config for VOI
    if (window.DIDataLayer && window.DIDataLayer.vars && window.DIDataLayer.vars.vehicle) {
        globalVehicle = window.DIDataLayer.vars.vehicle;
    }

    // Override with config setting
    if (
        settings.inlineConfig &&
        settings.inlineConfig.extraContext &&
        settings.inlineConfig.extraContext.vehicleOfInterest
    ) {
        overrideVehicle = settings.inlineConfig.extraContext.vehicleOfInterest;
    }

    if (globalVehicle || overrideVehicle) {
        if (settings.extraContext === undefined) {
            settings.extraContext = {};
        }

        settings.extraContext.vehicleOfInterest = { ...globalVehicle, ...overrideVehicle };
    }

    return settings;
};
export const getBrowserCapabilities = (state: RootState) => state.settings.browser;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/selectors/settings.ts